import Vue from 'vue/dist/vue.esm.js';

Vue.component('cart-widget', {
    template: `#cart-widget`,
    delimiters: ['[[', ']]'],
    props: {
        initialCart: {
            required: true,
            type: Object,
        },
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        removeCartRowUrl: {
            required: true,
            type: String,
        }
    },

    mounted() {
        EventManager.listen('item-added', this.cartUpdated);
        EventManager.listen('item-removed', this.cartUpdated);
    },

    data() {
        return {
            cart: this.initialCart,
        }
    },

    methods: {
        cartUpdated(data) {
            this.cart = JSON.parse(data);
        },

        removeRow(rowId, removeItemUrl) {
            this.buildAjax(rowId, removeItemUrl);
        },

        formattedPrice(price) {
            const symbols = {
                EUR: '€',
                BGN: 'лв.',
            };

            const symbol = symbols[this.currency] || this.currency;

            // Ensure price is a number and format to 2 decimals
            const parsedPrice = parseFloat(price).toFixed(2);

            const [whole, decimal] = parsedPrice.split('.');

            //return `${whole}<span class="coins">${decimal}</span> ${symbol}`;
            return `${whole}<sup class="coins" style="vertical-align: unset!important;"><small class="decimal">.</small>${decimal}</sup> ${symbol}`;
            //return `${whole}.${decimal} ${symbol}`;
        },


        buildAjax(rowId, url) {
            let _self = this
            $.ajax({
                data: {id: rowId},
                url: url,
                method: 'POST',
                success: function (result) {
                    _self.successAjax(result)
                },
            });
        },

        successAjax(result) {
            if (result.success === false) {
                return;
            }

            EventManager.fire('item-removed', result.cart);

            let event = {
                event: 'eec.remove',
                eventData: result.variant,
                action: 'CartWidget',
            }
            EventManager.fire('gtm-event',event);
        },
        concatenateAttributeValues(attributes) {
            let str = '';
            for (let [index,attribute] of attributes.entries()) {
                if(index !== 0){
                    str += ', '
                }
                if(attribute.showUnit){
                    str += attribute.unit + ' x '
                }
                str +=  ' ' + attribute.value;

            }
            return str;
        }
    },

    computed: {
        total() {
            return this.formattedPrice(this.cart.total)
        },
    }
});